import { PlayerPanelAltDesktop } from './PlayerPanelAlt';
import { PlayerPanelMobile } from './PlayerPanelMobile';
import { IPanelGame } from './types';

export type Props = {
  color: 'black' | 'white';
  orientation: 'top' | 'bottom';
  mobile?: boolean;
  timePressureSec?: number;
  game: IPanelGame;
  scoresheetTimeMs?: { white?: number; black?: number };
  isFirstMoveTime?: boolean;
  networkProblem?: boolean;
};

export function PlayerPanelWidget({
  color,
  orientation,
  mobile,
  timePressureSec = 10,
  game,
  scoresheetTimeMs,
  isFirstMoveTime = false,
  networkProblem,
}: Props) {
  // Новая версия для Desk

  if (!mobile)
    return (
      <PlayerPanelAltDesktop
        game={game}
        timePressureSec={timePressureSec}
        fractionsFromSec={timePressureSec}
        customPlayersTimeMs={scoresheetTimeMs}
        isFirstMoveTime={isFirstMoveTime}
        networkProblem={networkProblem}
        position={orientation}
        color={color}
      />
    );

  // Старая версия для Mobile

  return (
    <PlayerPanelMobile
      position={orientation}
      color={color}
      game={game}
      customPlayersTimeMs={scoresheetTimeMs}
      timePressureSec={timePressureSec}
      fractionsFromSec={timePressureSec}
      isFirstMoveTime={isFirstMoveTime}
      networkProblem={networkProblem}
    />
  );
}
